import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class HtmlUtilsService {

  constructor(private httpClient: HttpClient) { }

  public insertScript = (id: string, url: string) => {
    if (!document.getElementById(id)) {
      let $script = document.createElement('script');
      $script.src = url;
      $script.id = id;
      document.body.appendChild($script);
    }
  }

  public insertCssLinkFromAssets = (id: string, url: string) => {
    if (!document.getElementById(id)) {
      this.httpClient.get('/landings-static/assets/' + url).subscribe((response: any) => {
        this.insertCssLink(id, 'landings-static/' + response.url);
      })
    }
  }

  public insertCssLink = (id: string, url: string) => {
    if (!document.getElementById(id)) {
      let head = document.head || document.getElementsByTagName('HEAD')[0];
      let link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = url;
      link.id = id;
      head.appendChild(link);
    }
  }

  isVisible(element: any) {
    try {
      const style = window.getComputedStyle(element);
      return !(style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0' || element['offsetWidth'] === 0 || element['offsetHeight'] === 0)
    } catch (e) {
      throw new Error('Element not exist into DOM.');
    }
  }

  trackErrorToNR(className: any, type: string) {
    if (window.newrelic) {
      window.newrelic.addPageAction("error", {element: className, type: type});
    }
  }

  public checkVisibleElementOrThrowError(className: string) {
    try {
      let element = document.querySelector(className);
      if (!this.isVisible(element)) {
        throw new Error();
      }
      while (element) {
          if (!this.isVisible(element)) {
            throw new Error();
          }
          element = element.parentElement;
      }
    } catch (e) {
      this.trackErrorToNR(className, 'not-visible');
    }
  }
}
